/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateCampaignPipelineConfigDataSchema = z.object({
	stages: z.array(
		z.object({ name: z.string(), id: z.string().nullable().optional(), locked: z.boolean().nullable().optional() }),
	),
})

export type UpdateCampaignPipelineConfigDataSchema = z.infer<typeof updateCampaignPipelineConfigDataSchema>
